export const chevronUpIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.98 5a1 1 0 0 0-.707.29L3.292 9.287a1.002 1.002 0 0 0 .448 1.679 1 1 0 0 0 .965-.26l3.274-3.308 3.284 3.178c.25.279.633.394.994.298a1.002 1.002 0 0 0 .379-1.737L8.655 5.28A1 1 0 0 0 7.978 5z"/></svg>`,
    name: 'chevron-up' as const
};